import React from 'react';
import GrayCard from '../../../components/GrayCard';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Dropdown } from 'semantic-ui-react';
// import { Dropdown } from 'react-bootstrap';
import C3Chart from 'react-c3js';
import 'c3/c3.css';
import './RebateData.css';
import Select from 'react-select';
import {
    getCorporateVendorOverviewOverallVolumeCards, CorporateOverviewRebateNames,
    getCorporateOverviewVPPerformance, getCorporateOverviewMemberPerformance,
    getCorporateOverviewVPInvoices, getCorporateOverviewMPInvoices,
    getCorporateOverviewGrowthRebateVendortab, saveVendorId, saveMemberId, getMonthsFilter,tabTracking,
    getDashboardIndividualGrowthRebate
} from '../../../actions';
import _find from 'lodash/find';
import _isEqual from 'lodash/isEqual';
import _findIndex from 'lodash/findIndex';
import { PriceFormatter, PriceFormatter1, dynamicDateFilters1, monthName, monthName1, 
    jsonToParam, paramsToJSON, paramsToJSON1, PercentFormatter,PercentFormatter1,formatCurrency,
    formatPounds ,formatUnits } from '../../../helper';
import { differenceFormatter } from '../../../helper';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import Filters from '../../../components/Filters.jsx';
import { getCardTitle, VirtualizedPriceFormatter, VirtualizedDifferenceFormatter } from '../../../helper';
import accounting from 'accounting-js';
import { matLoader } from '../../../components/Loader';
import ReactExport from "react-export-excel";
import { Link } from 'react-router-dom';
import { Column, Table, AutoSizer, InfiniteLoader } from 'react-virtualized';
import swal from 'sweetalert';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import 'react-toastify/dist/ReactToastify.min.css';
import { Row,Col, Button, ButtonToolbar, OverlayTrigger, Tooltip } from 'react-bootstrap';


class RebateView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedFilterPeriod: "YTD",
            buttonOptionsPeriod: ["MTH", "YTD", "QTR"],
            showQuarter: false,
            dataval: [],
            items: [],
            selectedYear: new Date().getFullYear(),
            selectedItem: new Date().getMonth(),
            isLoading: true,
            params: {
                source: 'vendor',
                period: "YTD",
                ytd: "true",
                qtr: "false",
                mth: "false",
                year: 2022,
                month: 12,
                quarter: 1,
                buyingGroupId: 0,
                isCompliant: "A",
                "dropDown": [],
                subTabVendor: "Sales",
                subTabMember: "Purchase",
                startRowNo: 0,
                vendorName: '',
            },
            expanded: false,
            selectedFilterVolume: true,
            selectedFilterRebate: false,
            selectedFilter: "Sales",
            buttonOptions: ["Sales", "Rebate"],
            selectedFilterMemberVolume: true,
            selectedFilterMemberRebate: false,
            buttonOptionsGrowth:["Group Growth","Individual Growth"],
            selectedFilterGrowth:"Group Growth",
            selectedFilterGrowthstate: true,
            selectedFilterIndividualGrowth: false,
            selectedFilterVendor: "Purchase",
            buttonOptionsMember: ["Purchase", "Rebate"],
            groupRebatesListData: [],
            selectedGroupRebate: true,
        }

    }
    redirectToMember = false;
    redirectToVendor = false;

    redirectToMember = false;
    redirectToVendor = false;

    showMemberInvoice = false;
    showVendorInvoice = false;
    stopIndex = 1;
    handleUserSelectedFilter(option) {
        let obj = {};
         
        if (option === "qtr" || option === "QTR") {
            this.setState({ showQuarter: true });
        } else {
            this.setState({ showQuarter: false });
        }
       
    let paramsValues = this.state.params;
    let paramsfinal = paramsToJSON1(paramsValues);
    let month = paramsfinal.month;
    if(month >= 1 && month <= 3){
        paramsfinal.quarter= 1
    }
    else if(month >= 4 && month <= 6){
        paramsfinal.quarter = 2
    }
    else if(month >= 7 && month <= 9){
        paramsfinal.quarter = 3
    }
    else if(month >= 10 && month <= 12){
        paramsfinal.quarter = 4
    }
    
    let params = jsonToParam(paramsfinal);
            this.setState({ selectedFilterPeriod: option,params: params}, () => {
            this.setFilter({ period: this.state.selectedFilterPeriod, year: this.state.year, quarter: this.state.quarter, month: this.state.month, memberId: this.props.memberId });
        });
    }

    componentWillMount() {
        let paramsValues = this.state.params;
        let paramsfinal = dynamicDateFilters1(paramsValues);
        let params = jsonToParam(paramsfinal);

        console.log(params);
        this.setState({ params: params });
    }

    componentDidMount() {
        console.log('filters ', this.props.showMonth == "false");
        console.log(this.state.showQuarter);
        if (this.props.showMonth == "false" && this.state.showQuarter === false) {
            this.setState({ showQuarter: false, buttonOptionsPeriod: ["YTD", "QTR"], selectedFilterPeriod: "YTD" });
        }
        Promise.all([
            //this.props.getCorporateVendorOverviewOverallVolumeCardsAPI(this.state.params),
            this.props.tabTrackingAPI("tabId=12"),
            // this.props.getCorporateOverviewVPPerformanceAPI(this.state.params),
            // this.props.getCorporateOverviewMemberPerformanceAPI(this.state.params),
            // this.props.getCorporateOverviewGrowthRebateVendortabAPI(this.state.params),
            this.props.getMonthsFilterAPI(this.state.params),
           // this.props.getDashboardIndividualGrowthRebateAPI(this.state.params),
        ]).then(([groupRebatesData]) => {
            this.getOptions();
            this.getOptionsYear();
            this.setState({
                isLoading: false,
                // purchasedOrderRowsArr: data
                groupRebatesListData: groupRebatesData
            })
        }).catch(err => {

            this.setState({
                isLoading: false
            })
        })
        let checkStorage = localStorage.setItem('flag','11')
        setTimeout(function () { localStorage.removeItem("flag"); }, 5000);
    }

    actuallyLoadMore = (startIndex) => {
        // fake new data
        // let newItems = [];
        // let s = this.state.groupRebatesListData.length + 1;
        this.stopIndex != startIndex && this.setState({ params: { ...this.state.params, startRowNo: startIndex } }, () => {
            //sara
            // this.props.getCorporateOverviewGroupRebatesAPI(this.state.params).then(data => {
            //     let newGroupFetchDataWithOldData = [...this.state.groupRebatesListData, ...data];
            //     this.setState({
            //         groupRebatesListData: newGroupFetchDataWithOldData,
            //     })
            //     this.promiseResolve();
            // });
        })

        this.stopIndex = startIndex;

        // this.setState({ purchasedOrderRowsArr: this.state.purchasedOrderRowsArr.concat(newItems)})
        // resolve the promise after data where fetched
    }

    // componentWillReceiveProps(nextProps) {
    //     if(!_isEqual(this.state.groupRebatesListData, nextProps.corporateOverviewGroupRebates)){
    //     this.setState({ groupRebatesListData: _get(nextProps, 'corporateOverviewGroupRebates', []) })
    //     }
    // }

    loadMore = (index) => {
        console.log('index in load more', index)
        // if(this.state.params.startIndex != 1){
        // simulate a request
        this.actuallyLoadMore(index.startIndex + 1)
        return new Promise((resolve, reject) => {
            this.promiseResolve = resolve;
        })
    }
    handleChangeOfDropdown(event) {
        let params = this.state.params;
        params = paramsToJSON1(params);
                let obj = {};
                obj[event.name] = event.value;
                params.quarter = event.value;
                let quarter = params.quarter
                params = jsonToParam(params);
                this.setState({
                    quarter:quarter,
                    params: params})
                this.setState(obj, () => {
                    this.setFilter({ period: this.state.selectedFilter, quarter: this.state.quarter });
                });
        
            }
    handleChangeOfDropdownYear(e) {
        let params = this.state.params;
        params = paramsToJSON1(params);
        let year = ''
        let items =[]
        params.year = e.value
        year = params.year
        let selectedYear=  {label: year , value :year}
        let dataval = Object.keys(this.props.getMonthsFilter);
        let yearval = dataval.map((val) => {
            return {
                label: val,
                value: val,
            }
        })

        let selectedYear1 = yearval[yearval.length - 1];
        // if (selectedYear1.value != 2023 && e.value == 2023 )
        if (selectedYear1.value != 2024 && e.value == 2024 )
        {
            items = [{ label: monthName1(1),value: 1}];
        }
        else {
        let dataval1 = Object.values(this.props.getMonthsFilter[year]);
        if(typeof dataval1 == 'undefined')
            {
              items = [{ label: monthName1(1),value: 1}];
          
            }
            else{
              items = dataval1.map(itemval => {
                  return {
                      label: monthName1(itemval),
                      value: itemval,
                  }
      
              })
          }
        }
        
        let selectedItem = items[items.length - 1];
        params.month = selectedItem.value;
        let month = selectedItem.value;
        if (month >= 1 && month <= 3) {
            params.quarter = 1
        }
        else if (month >= 4 && month <= 6) {
            params.quarter = 2
        }
        else if (month >= 7 && month <= 9) {
            params.quarter = 3
        }
        else if (month >= 10 && month <= 12) {
            params.quarter = 4
        }
        params = jsonToParam(params);
        this.setState({
            params: params,
            selectedYear: selectedYear,
            items: items,
            selectedItem : selectedItem,
    })
    this.setState(e, () => {
        this.setFilter({ year: this.state.year, selectedYear: selectedYear,selectedItem:selectedItem });
    });

        // let params = this.state.params;
        // params = paramsToJSON1(params);
        // let year = ''
        // params.year = e.value
        // year = params.year
        // let selectedYear = { label: year, value: year }

        // params = jsonToParam(params);
        // this.setState({
        //     params: params,
        //     selectedYear: selectedYear,
        // }, this.getOptions)

        // console.log(this.state.selectedYear);


    }
    getOptionsYear() {
        let dataval = Object.keys(this.props.getMonthsFilter);
        let yearval = dataval.map((val) => {
            return {
                label: val,
                value: val,
            }
        })
        let selectedYear = yearval[yearval.length - 1];
        // if (selectedYear.value != 2021 && selectedYear.value != 2022 && selectedYear.value != 2023)
        if (selectedYear.value != 2021 && selectedYear.value != 2022 && selectedYear.value != 2023 && selectedYear.value != 2024)
        {
        yearval.push({ label: 2021, value: 2021 });
        yearval.push({ label: 2022, value: 2022 });
        yearval.push({ label: 2023, value: 2023 });
        yearval.push({ label: 2024, value: 2024 });
        }
        // else if (selectedYear.value != 2023 && selectedYear.value == 2022){
        else if (selectedYear.value != 2023 && selectedYear.value != 2024){
            yearval.push({ label: 2023, value: 2023 });
            yearval.push({ label: 2024, value: 2024 });
  
        }
                //add this new code

        else if (selectedYear.value != 2024){
            yearval.push({ label: 2024, value: 2024 });
  
        }
        // params = jsonToParam(params);
        this.setState({
            selectedYear: selectedYear,
            yearval: yearval,
            // params: params ,
        })
    }
    handleChangeOfDropdownMonth = (e) => {
        
        let params = this.state.params;
        params = paramsToJSON1(params);
        let month = ''
        params.month = e.value
        month = params.month
        let selectedItem = { label: monthName1(month), value: month }
        if(month >= 1 && month <= 3){
            params.quarter= 1
        }
        else if(month >= 4 && month <= 6){
            params.quarter = 2
        }
        else if(month >= 7 && month <= 9){
            params.quarter = 3
        }
        else if(month >= 10 && month <= 12){
            params.quarter = 4
        }
        params = jsonToParam(params);
        this.setState({
            params: params,
            selectedItem: selectedItem,

        })

        this.props.getCorporateVendorOverviewOverallVolumeCardsAPI(params)
        this.props.getCorporateOverviewVPPerformanceAPI(params)
        this.props.getCorporateOverviewMemberPerformanceAPI(params)
        this.props.getCorporateOverviewGrowthRebateVendortabAPI(params)
        this.props.getDashboardIndividualGrowthRebateAPI(params)



    }
    componentWillReceiveProps(props) {
        const { dataForChart1, dataForChart2 } = this.state;
        if (!_isEqual(this.state.dataForChart1, dataForChart1)) {
            this.setState({
                dataForChart1: {
                    data: {
                        columns: [
                            props.getCorporateBaseRebatesOverview.chartData1,
                            props.getCorporateBaseRebatesOverview.chartData2,
                            props.getCorporateBaseRebatesOverview.chart1,
                        ],
                        axes: {
                            data1: 'y',
                            data2: 'y2'
                        },
                    }
                }
            });
        }
        if (!_isEqual(this.state.dataForChart2, dataForChart2)) {
            this.setState({
                dataForChart2: {
                    data: {
                        columns: [
                            props.getCorporateBaseRebatesOverview.chartData11,
                            props.getCorporateBaseRebatesOverview.chartData22,
                        ],
                        axes: {
                            data1: 'y',
                            data2: 'y2'
                        },
                    }
                }
            });
        }
    }
    setFilter = (filter) => {
        console.log(filter);
        let params = this.state.params;
        params = paramsToJSON(params);
        if (filter.period === "qtr" || filter.period == "QTR") {
            params.qtr = "true";
            params.mth = "false";
            params.ytd = "false";
            // params.quarter = filter.quarter;
            // params.year = filter.year;
            params.period = filter.period;
        } else if (filter.period === "MTH" || filter.period == "mth") {
            params.qtr = "false";
            params.mth = "true";
            params.ytd = "false";
            // params.month = filter.month;
            // params.year = filter.year;
            params.period = filter.period;
        } else if (filter.period === "YTD" || filter.period == "ytd") {
            params.qtr = "false";
            params.mth = "false";
            params.ytd = "true";
            // params.year = filter.year;
            // params.month = filter.month;
            params.period = filter.period;
        }
        else if (filter.year != undefined) {
            params.year = filter.year;

        }
        else if (filter.month != undefined) {
            params.month = filter.month;

        }
        else if (filter.quarter != undefined) {
            params.quarter = filter.quarter;

        }
        else if (filter.isCompliant != undefined) {
            params.isCompliant = filter.isCompliant;

        }
        else if (filter.buyingGroupId == undefined) {
            params.buyingGroupId = params.buyingGroupId;

        }
        else if (filter.buyingGroupId != undefined || filter.isCompliant == undefined) {
            params.buyingGroupId = filter.buyingGroupId;
            params.isCompliant = params.isCompliant;

        }
        else if (filter.isCompliant != undefined || filter.buyingGroupId == undefined) {
            params.isCompliant = filter.isCompliant;
            params.buyingGroupId = params.buyingGroupId;

        }
        params = jsonToParam(params);
        this.setState({
            buyingGroupId: params.buyingGroupId,
            isCompliant: params.isCompliant,
            params: params,
            refreshData: true,
            isLoading: true
        }, () => Promise.all([
            // this.props.getCorporateOverviewGroupRebatesAPI(this.state.params),
            // this.props.getCorporateOverviewRebateNamesAPI(),
            // this.props.getCorporateOverviewSourceNamesAPI(),
            // this.props.getCorporateOverviewGroupRebateNamesAPI(),
            this.props.getCorporateVendorOverviewOverallVolumeCardsAPI(this.state.params),
            // this.props.getCorporateOverviewRebateTypeCardsAPI(this.state.params),
            this.props.getCorporateOverviewVPPerformanceAPI(this.state.params),
            this.props.getCorporateOverviewMemberPerformanceAPI(this.state.params),
            this.props.getCorporateOverviewGrowthRebateVendortabAPI(this.state.params),
            this.props.getDashboardIndividualGrowthRebateAPI(this.state.params),
        ]).then(([groupRebateData]) => {
            this.setState({
                isLoading: false,
                groupRebatesListData: groupRebateData
            })
        }).catch(err => {

            this.setState({
                isLoading: false
            })
        }))
    }
    handleChangeOfDropdownextra(event) {
        let obj = {};
        obj[event.name] = event.value;
        this.setState(obj, () => {

            //params= paramsToJSON(params);
            this.setFilter({ buyingGroupId: this.state.buyingGroupId, isCompliant: this.state.isCompliant });
            //params= jsonToParam(params);
        });
    }
    handleUserSelectedFilterVP = (option) => {

        if (option === "Sales") {
            this.setState({ selectedFilter: "Sales", selectedFilterVolume: true, selectedFilterRebate: false })
            let params = this.state.params;
            params = paramsToJSON(params);
            params.subTabVendor = option;
            params = jsonToParam(params);
            this.props.getCorporateOverviewVPPerformanceAPI(params);
        } else {
            this.setState({ selectedFilter: "Rebate", selectedFilterRebate: true, selectedFilterVolume: false })
            let params = this.state.params;
            params = paramsToJSON(params);
            params.subTabVendor = "";
            params = jsonToParam(params);
            this.props.getCorporateOverviewVPPerformanceAPI(params);
        }

    }
    renderButtonGroupVP() {

        return this.state.buttonOptions.map((option, index) => {
            return (
                <div>
                    <button key={index} type="button" value={option}
                        onClick={(e) => this.handleUserSelectedFilterVP(e.target.value)}
                        className={`btn btn-light ${(this.state.selectedFilter === "Sales" && index == 0) ? "active" : (this.state.selectedFilter === "Rebate" && index == 1) ? "active" : null}`}
                    >{option}</button>
                </div>
            )
        })
    }

    handleUserSelectedFilterMember(option) {
        if (option === "Purchase") {
            this.setState({ selectedFilterVendor: "Purchase", selectedFilterMemberVolume: true, selectedFilterMemberRebate: false })
            let params = this.state.params;
            params = paramsToJSON(params);
            params.subTabMember = option;
            params.dropDown = [];
            params = jsonToParam(params);
            this.props.getCorporateOverviewMemberPerformanceAPI(params);
        } else {
            this.setState({ selectedFilterVendor: "Rebate", selectedFilterMemberVolume: false, selectedFilterMemberRebate: true })
            let params = this.state.params;
            params = paramsToJSON(params);
            params.subTabMember = "";
            params.dropDown = [];
            params = jsonToParam(params);

            this.props.getCorporateOverviewMemberPerformanceAPI(params);
        }

    }

    renderButtonGroupMember() {

        return this.state.buttonOptionsMember.map((option, index) => {
            return (
                <button key={index} type="button" value={option}
                    onClick={(e) => this.handleUserSelectedFilterMember(e.target.value)}
                    className={`btn btn-light ${(this.state.selectedFilterVendor === "Purchase" && index == 0) ? "active" : (this.state.selectedFilterVendor === "Rebate" && index == 1) ? "active" : null}`}
                >{option}</button>
            )
        })
    }

    handleRebateNameClick = (e, value) => {
        let params = this.state.params;
        params = paramsToJSON(params);
        params.dropDown = [{ "rebate": [e.target.textContent] }]
        params = jsonToParam(params);

        this.props.getCorporateOverviewRebateTypeCardsAPI(params);
    }

     //Toggle button for corporate individual growth 
     /// 

renderGrowthTiers = ( growthTier) => {
    
    console.log('Rendering Tiers', growthTier);
    let variant = 'success';
    let minimumAttainment = Math.min.apply(null, Array.from(growthTier.rebateTierCriteria.map(tierCriteria => tierCriteria.attainmentPercent)));
    if (minimumAttainment <= 50) {
        variant = 'danger';
    } else if (minimumAttainment < 100) {
        variant = 'warning';
    }
    return (
        <OverlayTrigger overlay={(<Tooltip>{
            <React.Fragment>
                <div className="m-1 p-1 text-left" style={{ 'backgroundColor': 'rgba(255, 255, 255, 0.05)' }}>{"GROWTH"}</div> 
                <div className="m-1 p-1 text-left" style={{ 'backgroundColor': 'rgba(255, 255, 255, 0.05)' }}>Tier: {growthTier.tier}</div>
                {growthTier.rebateTierCriteria.map((criteria, index) => {
                        if (criteria.criteriaSetting == 'Absolute') {
                        return <div className="m-1 p-1 text-left" style={{ 'backgroundColor': 'rgba(255, 255, 255, 0.05)' }}>
                            <div>Criteria {(index + 1) + ': ' + criteria.criteria}</div>
                           
                          <div>Condition : {PriceFormatter1(criteria.requiredGrowth)}  <i class="fa fa-arrow-up" aria-hidden="true"></i></div>
                          <div>Target : {PriceFormatter1(criteria.target)}</div>
                            <div>Actual : {PriceFormatter1(criteria.actual)}</div>
                            <div>Gap : {PriceFormatter1(criteria.gap)}</div>
                            <div>Attainment : {PercentFormatter(criteria.attainmentPercent)}</div>
                        </div>
                        }
                        else if (criteria.criteriaSetting == 'Percentage') {
                            return <div className="m-1 p-1 text-left" style={{ 'backgroundColor': 'rgba(255, 255, 255, 0.05)' }}>
                                <div>Criteria {(index + 1) + ': ' + criteria.criteria}</div>
                               
                              <div>Condition : {PercentFormatter1(criteria.requiredGrowth)}  <i class="fa fa-arrow-up" aria-hidden="true"></i></div>
                              <div>Target : {PriceFormatter1(criteria.target)}</div>
                                <div>Actual : {PriceFormatter1(criteria.actual)}</div>
                                <div>Gap : {PriceFormatter1(criteria.gap)}</div>
                                <div>Attainment : {PercentFormatter(criteria.attainmentPercent)}</div>
                            </div>
                            }
                    })}
            </React.Fragment>
        }</Tooltip>)}
            popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">
            <Col style={{ 'padding': '1px' }}>
                <div className={'bg-' + variant} style={{ 'width': '100%', 'height': '15px' }}></div>
                </Col>
        </OverlayTrigger>
        // END COL
    )
    
};

GrowthTier = (cell, rows) => {
    
    console.log('Growth Rebate', rows.rebateTierVendor);
    if (rows.rebateTierVendor && rows.rebateTierVendor.length > 0) {
        return <React.Fragment>{rows.rebateTierVendor.map(rebateProgram =>
            <Row style={{ width: '100px', flexWrap: 'inherit !important' }} className="ml-2">
                {/* {rebateProgram.rebateTierCriteria.map(programTiers =>  */}
                   { this.renderGrowthTiers(rebateProgram)
                    }
            </Row>)
        }</React.Fragment>;
    } else {
        return <div></div>;
    };
};

RebateVerified = (cell,rows) =>
{
    // if (rows.rebatePercentList && rows.rebatePercentList > 0) {
        return <React.Fragment>
            {rows.rebatePercentList.map(rebatePercent=>
            <Row style={{ width: '100px', flexWrap: 'inherit !important' }} className="ml-2">
                 {/* {<Row style={{ marginBottom: '4px' }}>{rebatePercent}</Row>} */}
                 <div className={"tier"} style={{ marginBottom: '4px' }}>{Number(rebatePercent).toFixed(1)}</div>
            </Row>)
        }</React.Fragment>;
    // } else {
    //     return <div></div>;
    // };
    
};
 


     renderButtonGrowthIndividual() {

        return this.state.buttonOptionsGrowth.map((option, index) => {
            return (
                <div>
                    <button key={index} type="button" value={option}
                        onClick={(e) => this.handleUserSelectedIndividualGrowth(e.target.value)}
                        className={`btn btn-light ${(this.state.selectedFilterGrowth === "Group Growth" && index == 0) ? "active" : (this.state.selectedFilterGrowth === "Individual Growth" && index == 1) ? "active" : null}`}
                    >{option}</button>
                </div>
            )
        })
    }

    handleUserSelectedIndividualGrowth(option) {
        if (option === "Group Growth") {
            this.setState({ selectedFilterGrowth: "Group Growth", selectedFilterGrowthstate: true, selectedFilterIndividualGrowth: false })
            let params = this.state.params;
            params = paramsToJSON(params);
            params.subTabMember = option;
            params.dropDown = [];
            params = jsonToParam(params);
            this.props.getCorporateOverviewGrowthRebateVendortabAPI(params);
        } else {
            this.setState({ selectedFilterGrowth: "Individual Growth", selectedFilterGrowthstate: false, selectedFilterIndividualGrowth: true })
            let params = this.state.params;
            params = paramsToJSON(params);
            params.subTabMember = "";
            params.dropDown = [];
            params = jsonToParam(params);
            this.props.getDashboardIndividualGrowthRebateAPI(params);
        }

    }

    //


    
    selectRowProp = {
        mode: "radio",
        hideSelectColumn: true,
        clickToSelect: true,
        hideSelectAll: true,
        bgColor: "rgb(0,0,255)",
        onSelect: (row, isSelect, rowIndex, e) => {
            if (isSelect) {
                return true;
            }
        }
    };
    handleVPNameClick = (e, value) => {
        let params = this.state.params;
        let arr = [];
        if (value.value.length > 0) {
            let valueee = value.value.map((option, index) => {
                let val = _find(value.options, ['key', option])
                arr.push(val.text)
            })
            let isVpName = _find(params.dropDown, 'vendorPartner');
            if (isVpName) {
                isVpName.vendorPartner = arr;
            } else {
                params.dropDown = [...params.dropDown, {
                    vendorPartner: arr
                }];
            }

        }
        else {
            let isVpName = _findIndex(params.dropDown, 'vendorPartner');
            let p = (isVpName >= 0) ? params.dropDown.splice(isVpName, 1) : params.dropDown;
            // params.dropDown = []
        }
        params.startRowNo = 0;
        // sara For api chnage have to change
        // this.props.getCorporateOverviewGroupRebatesAPI(params).then(data => {
        //     this.setState({
        //         groupRebatesListData: data,
        //     })
        // });
    }

    getOptions() {
        let params = this.state.params;
        params = paramsToJSON(params);
        let items = []
        // items = this.props.getMonthsFilter[params.year].map(itemval => {
        //     return {
        //         label: monthName1(itemval),
        //         value: itemval,
        //     }

        // })
        let dataval = Object.keys(this.props.getMonthsFilter);
        let yearval = dataval.map((val) => {
            return {
                label: val,
                value: val,
            }
        })
        let selectedYear1 = yearval[yearval.length - 1];

        let dataval1 = Object.values(this.props.getMonthsFilter[selectedYear1.value]);
        if(typeof dataval1 == 'undefined')
            {
              items = [{ label: monthName1(1),value: 1}];
          
            }
            else{
              items = dataval1.map(itemval => {
                  return {
                      label: monthName1(itemval),
                      value: itemval,
                  }
      
              })
          }

        if (selectedYear1.value != 2022)
        {
        yearval.push({ label: 2022, value: 2022 });
        }
        let selectedItem = items[items.length - 1];
        params.month = selectedItem.value;
        params.year = selectedYear1.value;
        let month = selectedItem.value;
        if(month >= 1 && month <= 3){
            params.quarter= 1
        }
        else if(month >= 4 && month <= 6){
            params.quarter = 2
        }
        else if(month >= 7 && month <= 9){
            params.quarter = 3
        }
        else if(month >= 10 && month <= 12){
            params.quarter = 4
        }
        params = jsonToParam(params);
        this.setState({
            items: items,
            selectedItem: selectedItem,
            params: params,
        })
        this.props.getCorporateVendorOverviewOverallVolumeCardsAPI(params)
        // this.props.getCorporateOverviewRebateTypeCardsAPI(this.state.params),
        this.props.getCorporateOverviewVPPerformanceAPI(params)
        this.props.getCorporateOverviewMemberPerformanceAPI(params)
        this.props.getCorporateOverviewGrowthRebateVendortabAPI(params)
        this.props.getDashboardIndividualGrowthRebateAPI(params)

    }

    renderButtonGroup() {

        return this.state.buttonOptionsPeriod.map((option, index) => {
            return (
                <button style ={{height:'38px'}} key={index} type="button" value={option}
                    onClick={(e) => { console.log(e.target.value); this.handleUserSelectedFilter(e.target.value) }}
                    class={`btn btn-light ${(this.state.selectedFilterPeriod === option) ? "active" : null}`}>{option}</button>
            )
        })
    }

    handleProgramTypeClick = (e, value) => {
        let params = this.state.params;
        let arr = [];
        if (value.value.length > 0) {
            let valueee = value.value.map((option, index) => {
                let val = _find(value.options, ['key', option])
                arr.push(val.text)
            })
            let isProgramName = _find(params.dropDown, 'rebateType');
            if (isProgramName) {
                isProgramName.rebateType = arr;
            } else {
                params.dropDown = [...params.dropDown, {
                    rebateType: arr
                }];
            }

        }
        else {
            let isProgramName = _findIndex(params.dropDown, 'rebateType');
            let p = (isProgramName >= 0) ? params.dropDown.splice(isProgramName, 1) : params.dropDown;
            // params.dropDown = []
        }
        console.log("djshdjkhsjdhsajdhsadksa", params)
        params.startRowNo = 0;

        // sara
        // this.props.getCorporateOverviewGroupRebatesAPI(params).then(data => {
        //     this.setState({
        //         groupRebatesListData: data,
        //     })
        // });
    }
    handleDataSourceClick = (e, value) => {
        let params = this.state.params;
        let arr = [];
        if (value.value.length > 0) {
            let valueee = value.value.map((option, index) => {
                let val = _find(value.options, ['key', option])
                arr.push(val.text)
            })
            let isSourceName = _find(params.dropDown, 'source');
            if (isSourceName) {
                isSourceName.source = arr;
            } else {
                params.dropDown = [...params.dropDown, {
                    source: arr
                }];
            }

        }
        else {
            let isSourceName = _findIndex(params.dropDown, 'source');
            let p = (isSourceName >= 0) ? params.dropDown.splice(isSourceName, 1) : params.dropDown;
            // params.dropDown = []
        }
        console.log("djshdjkhsjdhsajdhsadksa", params)
        params.startRowNo = 0;
        //sara
        // this.props.getCorporateOverviewGroupRebatesAPI(params).then(data => {
        //     this.setState({
        //         groupRebatesListData: data,
        //     })
        // });
    }

    showMemberIcon = (cell, row) => {

        return (
            <OverlayTrigger overlay={(<Tooltip id="hi">View {row.memberName} Dashboard</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">

<Link to='/Member/MemberData' onClick={async (e) => {
        e.stopPropagation();
        e.preventDefault();
        this.redirectToMember = true;
        sessionStorage.setItem('imark-memberId', row.memberId);
        sessionStorage.setItem('imark-memberName', row.memberName);
        sessionStorage.setItem('imark-buyingGroupId', row.memberBuyingGroup);
        localStorage.setItem('imark-Id', row.memberId);
        localStorage.setItem('imark-memberName', row.memberName);
        localStorage.setItem('imark-buyingGroupId', row.memberBuyingGroup);
        setTimeout(() => window.open(process.env.PUBLIC_URL + '#/Member/MemberData'), 1000);
      }}><i className='fas fa-laptop'></i></Link>
            </OverlayTrigger>
        )
    }
    showMemberPopUp = (cell, row) => {
        return (
            <OverlayTrigger overlay={(<Tooltip id="hi">View Invoices/PO for {row.memberName}</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">

                <Link onClick={(e) => {
                    e.preventDefault();
                    this.showMemberInvoice(row)
                }}> <i className="fas fa-th-list"></i></Link>
            </OverlayTrigger>
        )
    }
    showMemberInvoice = (row) => {

        this.setState({ memberId: row.memberId, memberName: row.memberName, showMemberInvoice: true }, () => {

            let selections = this.state.params;
            selections = paramsToJSON(selections);
            selections.memberId = this.state.memberId;

            selections = jsonToParam(selections);
            console.log(selections);
            this.props.getCorporateOverviewMPInvoicesAPI(selections, (res) => {
                toast(res.data.message);
            });
            // this.setState({ showProductListModal: false});
        });
    }
    closeMemberInvoice = () => {
        this.setState({ showMemberInvoice: false });
    }
    showVendorIcon = (cell, row) => {

        return (
            <OverlayTrigger overlay={(<Tooltip id="hi">View {row.vendorName} Dashboard</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">

        <Link to='/Vendor' onClick={async (e) => {
        e.stopPropagation();
        e.preventDefault();
        this.redirectToVendor = true;
        sessionStorage.setItem('imark-vendorId', row.vendorId);
        sessionStorage.setItem('imark-vendorName', row.vendorName);
        localStorage.setItem('imark-vendorId', row.vendorId);
        localStorage.setItem('imark-vendorName', row.vendorName);
        setTimeout(() => window.open(process.env.PUBLIC_URL + '#/Vendor'), 1000);
      }}><i className='fas fa-laptop'></i></Link>
            </OverlayTrigger>
        )
    }
    showVendorInfo = (cell, row) => {
        return (
            <OverlayTrigger overlay={(<Tooltip id="hi">View Invoices/PO for {row.vendorName}</Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">

                <Link onClick={(e) => {
                    e.preventDefault();
                    this.showVendorInvoice(row)
                }} ><i className="fas fa-th-list"></i></Link>
            </OverlayTrigger>
        )
    }
    showVendorInvoice = (row) => {
        //
        this.setState({ vendorId: row.vendorId, vendorName: row.vendorName, showVendorInvoice: true }, () => {

            let selections = this.state.params;
            selections = paramsToJSON(selections);
            selections.vendorId = this.state.vendorId;

            selections = jsonToParam(selections);
            console.log(selections);
            this.props.getCorporateOverviewVPInvoicesAPI(selections, (res) => {
                toast(res.data.message);
            });
            // this.setState({ showProductListModal: false});
        });
    }
    closeVendorInvoice = () => {
        this.setState({ showVendorInvoice: false });
    }
    createCustomClearButtonForVendor = (onClick) => {
        return (
            <button
                className='btn btn-primary '
                style={{'height': '24px','font-size': '11px','font-weight': '700',
                'font-stretch': 'extra-expanded' }}
                onClick={(e) => this.clearVendorFilter(onClick)}
            >
            Clear All
            </button>
        );
    };

    createCustomClearButtonForMember= (onClick) => {
        return (
            <button
                className='btn btn-primary '
                style={{'height': '24px','font-size': '11px','font-weight': '700',
                'font-stretch': 'extra-expanded'}}
                onClick={(e) => this.clearMemberFilter(onClick)}
            >
            Clear All
            </button>
        );
    };

    handleRowClickOfMember = row => {
        if (this.redirectToMember == false) {
            // you can do anything with row on here.
            let params = this.state.params;
            params = paramsToJSON(params);
            // params.dropDown = [{ "memberName": [encodeURIComponent(row.memberName)] }]
            params.memberId = encodeURIComponent(row.memberId)
            params.subTabMember = this.state.selectedFilterMemberVolume == true ? "Purchase" : "Rebate";
            params = jsonToParam(params);
            this.props.getCorporateOverviewVPPerformanceAPI(params);
            // this.redirectToMember = true;
        }
    }
    handleRowClickOfVendor = row => {
        if (this.redirectToVendor == false) {
            let params = this.state.params;
            // you can do anything with row on here.
            params = paramsToJSON(params);
            params.subTabVendor = this.state.selectedFilterVolume == true ? "Sales" : "Rebate";
            //  params.dropDown = [{ "vendorName": [encodeURIComponent(row.vendorName)] }]
            params.vendorId = encodeURIComponent(row.vendorId)

            params = jsonToParam(params);

            this.props.getCorporateOverviewMemberPerformanceAPI(params);
            // this.redirectToVendor = true;
        }
    }
    clearMemberFilter(onClick) {
        
        onClick();
        this.refs.memberperformance.cleanSelected();
        let params = this.state.params;
        params = paramsToJSON(params);
        params.memberId = "";
        params.vendorId = "";
        params = jsonToParam(params)
        this.setState({ params: params }, () => {
            this.props.getCorporateOverviewMemberPerformanceAPI(params);
            this.props.getCorporateOverviewVPPerformanceAPI(params);
        });
        this.refs.memberperformance.reset();
    }
    clearVendorFilter(onClick) {
        onClick();
        this.refs.vpperformance.cleanSelected();
        let params = this.state.params;
        params = paramsToJSON(params);
        params.memberId = "";
        params.vendorId = "";
        params = jsonToParam(params)
        this.setState({ params: params }, () => {
            this.props.getCorporateOverviewVPPerformanceAPI(params);
            this.props.getCorporateOverviewMemberPerformanceAPI(params)
        });
        this.refs.vpperformance.reset();
    }

    ProgressBarVendorPerformanceSales = (cell, row) => {
        //;
        //  this.corporateOverviewVPPerformance =[];
        this.corporateOverviewVPPerformance.push(row.vendorSalesRebate)
        let max = Math.max(...this.corporateOverviewVPPerformance);
        let str = accounting.formatMoney(cell);
        str = str.slice(0, -3);
        return (
            <React.Fragment>
                <div className="progress">

                    <div className="progress-bar" role="progressbar"
                        aria-valuemin="0" style={{ width: (cell / max) * 100 }}>
                    </div>
                </div>

            </React.Fragment>

        )
    }
    ProgressBarVendorPerformanceRebate = (cell, row) => {
        //;
        //  this.corporateOverviewVPPerformance =[];
        this.corporateOverviewVPPerformance.push(row.vendorTotalRebate)
        let max = Math.max(...this.corporateOverviewVPPerformance);
        let str = accounting.formatMoney(cell);
        str = str.slice(0, -3);
        return (
            <React.Fragment>
                <div className="progress">

                    <div className="progress-bar" role="progressbar"
                        aria-valuemin="0" style={{ width: (cell / max) * 100 }}>
                    </div>
                </div>

            </React.Fragment>

        )
    }
    TierComponent = (cell, rows) => {
        let tier = _get(rows, 'tier', "")
        if (tier) {
            return <div className="tier">{tier}</div>
        }
    }
    TierCriteria = (cell, rows) => {
        let sales = '$0';
        return <React.Fragment>

            {rows.criteria.map(sales =>
                <Row style={{ overflowWrap: 'break-word', width: '100px', flexWrap: 'inherit !important' }} className="ml-2">
                    {<Row style={{ marginBottom: '4px' }}>{sales}</Row>}
                </Row>

            )}
        </React.Fragment>

    }
    currentYearSales = (cell, rows) => {
        let sales = '$0';
        return <React.Fragment>

            {rows.currentYearSales.map(sales =>
                <Row style={{ overflowWrap: 'break-word', width: '100px', flexWrap: 'inherit !important' }} className="ml-2">
                    {sales = PriceFormatter1(sales),
                        <Row style={{ marginBottom: '4px' }}>{sales}</Row>
                    }
                </Row>
            )}

        </React.Fragment>

    }
    TargetSales = (cell, rows) => {
        let sales = '$0';
        return <React.Fragment>
            {rows.targetSales.map(sales =>
                <Row style={{ overflowWrap: 'break-word', width: '100px', flexWrap: 'inherit !important' }} className="ml-2">
                    {sales = PriceFormatter1(sales),
                        <Row style={{ marginBottom: '4px' }}>{sales}</Row>
                    }
                </Row>
            )}

        </React.Fragment>
    }
    gapAmount = (cell, rows) => {
        let sales = '$0';
        return <React.Fragment>
            {rows.gapAmount.map(sales => {
                if (sales >= 0) {
                    return (
                        <Row style={{ marginBottom: '4px', width: '100px', flexWrap: 'inherit !important' }} className="ml-2">

                            <div className={"greenText"}>{PriceFormatter1(sales)}</div>

                        </Row>
                    )
                }
                else if (sales >= 0) {
                    return (
                        <Row style={{ marginBottom: '4px', width: '100px', flexWrap: 'inherit !important' }} className="ml-2">

                            <div className={"redText"}>{PriceFormatter1(sales)}</div>

                        </Row>
                    )
                }
            })
            }
        </React.Fragment>
    }

    AttainmentComp = (cell, rows) => {

        let percentAttained = '0.00';
        return <React.Fragment>
            {rows.attainmentPercent.map(percentAttained => {
                if (percentAttained >= 100) {
                    return (
                        // <OverlayTrigger overlay={(<Tooltip> 
                        // {rows.criteria.map((criteria , index) => "Attainment percent for" + criteria)} </Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">

                        <Row style={{ marginBottom: '4px' }}>

                            <div className={"attainmentGreen"}>{Number(percentAttained).toFixed(1)}</div>

                        </Row>
                        // </OverlayTrigger>
                    )
                }
                if (percentAttained >= 75 && percentAttained < 100) {
                    return (
                        // <OverlayTrigger overlay={(<Tooltip> 
                        // {rows.criteria.map(criteria => "Attainment percent for" + criteria)} </Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">

                        <Row style={{ marginBottom: '4px' }}>
                            <div className={"attainmentYellow"}>{Number(percentAttained).toFixed(1)}</div>

                        </Row>
                        // </OverlayTrigger>
                    )
                }
                if (percentAttained >= 0 && percentAttained < 75) {
                    return (
                        // <OverlayTrigger overlay={(<Tooltip> 
                        // {rows.criteria.map(criteria => "Attainment percent for" + criteria)} </Tooltip>)} popperConfig={{ modifiers: { preventOverflow: { boundariesElement: 'viewport' } } }} placement="top">

                        <Row style={{ marginBottom: '4px' }}>
                            <div className={"attainmentRed"}>{Number(percentAttained).toFixed(1)}</div>

                        </Row>
                        // </OverlayTrigger>
                    )
                }
            })
            }
        </React.Fragment>
    }
    renderSizePerPageDropDown = props => {
        return (
          <div className='btn-group'>
            {
              [ 25, 50, 100 ].map((n, idx) => {
                const isActive = (n === props.currSizePerPage) ? 'active' : null;
                return (
                  <button key={ idx } type='button' className={ `btn btn-info ${isActive}` } onClick={ () => props.changeSizePerPage(n) }>{ n }</button>
                );
              })
            }
          </div>
        );
      }
    renderPaginationShowsTotal(start, to, total) {
        return (
            <p style={{ color: '' }}>
                Showing rows { start} to { to}
            </p>
        );
    }

    PoundSalesCalculation = (cell, rows) => {
       
        let salesCurrentYear = _get(rows, 'currentYearSales', 0);
        
        return <React.Fragment>
        {rows.criteria.map((criteriaName , index) => {
            console.log("ssssssssssss",criteriaName.toLowerCase())
        if (criteriaName.toLowerCase().includes('sales')) {
            
                
            return ( 
               
                <Row style={{ marginLeft: '10px', marginBottom: '4px' }}>
                          <div>{formatCurrency(salesCurrentYear[index])}</div>
                   
                      
                   </Row>
                   )
                    
            
            
        } 
        else if (criteriaName.toLowerCase().includes('pounds'))  {
            
            return ( 
                
                <Row style={{ marginLeft: '10px', marginBottom: '4px' }}>
                <div>{formatPounds(salesCurrentYear[index])}</div>
         
            
         </Row>
         )
                    
        }
     else if (criteriaName.toLowerCase().includes('units')) {
        
        return ( 
                
            <Row style={{ marginLeft: '10px', marginBottom: '4px' }}>
            <div>{formatUnits(salesCurrentYear[index])}</div>
     
        
     </Row>
     )
                
    }
} )}
</React.Fragment>
    }
    PoundCurrencyRebateCalculation = (cell, rows) => {

        //   let criteriaName = _get(rows, 'criteria', 0);
           let rebateAmount = _get(rows, 'rebateAmount', 0);
           return <React.Fragment>
           {rows.criteria.map((criteriaName , index) => {
               
           if (criteriaName.toLowerCase().includes('sales') ) {
               
                   
               return ( 
                   
                   <Row style={{ marginLeft: '10px', marginBottom: '4px' }}>
                             <div className = 'greenText'>{formatCurrency(rebateAmount)}</div>
                     
                      
                      </Row>
                       )
               
               
           } 
           else if (criteriaName.toLowerCase().includes('pounds'))  {
               
               return ( 
                   
                   <Row style={{ marginLeft: '10px', marginBottom: '4px' }}>
                             <div className = 'greenText'>{formatPounds(rebateAmount)}</div>
                     
                      
                      </Row>
                       )
           }
        else if (criteriaName.toLowerCase().includes('units')) {
           
           return ( 
                   
               <Row style={{ marginLeft: '10px', marginBottom: '4px' }}>
               <div className = 'greenText'>{formatUnits(rebateAmount)}</div>
       
        
        </Row>
                   )
       }
   } )}
   </React.Fragment>
   
   
       }

    PoundCurrencyGapCalculation = (cell, rows) => {

     //   let criteriaName = _get(rows, 'criteria', 0);
        let gap = _get(rows, 'gapAmount', 0);
        return <React.Fragment>
        {rows.criteria.map((criteriaName , index) => {
            
        if (criteriaName.toLowerCase().includes('sales') ) {
            
                
            return ( 
                
                <Row style={{ marginLeft: '10px', marginBottom: '4px' }}>
                          <div className = 'greenText'>{formatCurrency(gap[index])}</div>
                  
                   
                   </Row>
                    )
            
            
        } 
        else if (criteriaName.toLowerCase().includes('pounds'))  {
            
            return ( 
                
                <Row style={{ marginLeft: '10px', marginBottom: '4px' }}>
                          <div className = 'greenText'>{formatPounds(gap[index])}</div>
                  
                   
                   </Row>
                    )
        }
     else if (criteriaName.toLowerCase().includes('units')) {
        
        return ( 
                
            <Row style={{ marginLeft: '10px', marginBottom: '4px' }}>
            <div className = 'greenText'>{formatUnits(gap[index])}</div>
    
     
     </Row>
                )
    }
} )}
</React.Fragment>


    }
    PoundCurrencyLYCalculation = (cell, rows) => {

        let criteriaName = _get(rows, 'criteria', 0);
        let salesCurrentYear = _get(rows, 'salesCurrentYear', 0);
        let salesLastYear = _get(rows, 'salesLastYear', 0);
        let target = _get(rows, 'target', 0);
        let gap = _get(rows, 'gap', 0);


        if (criteriaName.toLowerCase().includes('sales') ) {
            return (
                <div >{formatCurrency(salesLastYear)}</div>
            )
        } else if (criteriaName == "Pounds CY"|| criteriaName == "Pounds LY" || criteriaName == "Group_Pounds LY" || criteriaName == "Group_Pounds CY")  {
            return (
                <div >{formatPounds(salesLastYear)}</div>
            )
        }
        else if (criteriaName.toLowerCase().includes('units')) {
            return (
                <div >{formatUnits(salesLastYear)}</div>
            )
        }


    }
    PoundCurrencyTargetCalculation = (cell, rows) => {

        let criteriaName = _get(rows, 'criteria', 0);
        let target = _get(rows, 'targetSales', 0);

        return <React.Fragment>
        {rows.criteria.map((criteriaName , index) => {
            
        if (criteriaName.toLowerCase().includes('sales')) {
            
                
            return ( 
                
                <Row style={{ marginLeft: '10px', marginBottom: '4px' }}>
                          <div className = 'greenText'>{formatCurrency(target[index])}</div>
                   
                   </Row>
                    )
            
            
        } 
        else if (criteriaName.toLowerCase().includes('pounds'))  {
            
            return ( 
                
                <Row style={{ marginLeft: '10px', marginBottom: '4px' }}>
                          <div className = 'greenText'>{formatPounds(target[index])}</div>
                   
                   </Row>
                    )
        }
     else if (criteriaName.toLowerCase().includes('units')) {
        
        return ( 
                
            <Row style={{ marginLeft: '10px', marginBottom: '4px' }}>
                          <div className = 'greenText'>{formatUnits(target[index])}</div>
                   
                   </Row>
                )
    }
} )}
</React.Fragment>


    }

    render() {
        let growthRebateExcelData = [];
        this.props.corporateOverviewGrowthRebateVendortab.forEach(row => {
            row.criteria.forEach((criteira, index) => {
                growthRebateExcelData.push({
                    ...row,
                    criteria: criteira,
                    currentYearSales: row.currentYearSales[index],
                    targetSales: row.targetSales[index],
                    gapAmount: row.gapAmount[index],
                    attainmentPercent:Number(row.attainmentPercent[index]).toFixed(1)
                });
            });
        });
        const { showQuarter } = this.state;

     

        const handleRowClickOfMember = {
            onRowClick: this.handleRowClickOfMember,
            sizePerPageDropDown: this.renderSizePerPageDropDown,
            bgColor: "rgb(0,123,255)",
            clearSearch: true,
            clearSearchBtn: this.createCustomClearButtonForMember,
            // paginationShowsTotal: this.renderPaginationShowsTotal,
            // sizePerPage: 100,
        }
        const handleRowClickOfVendor = {
            onRowClick: this.handleRowClickOfVendor,
            sizePerPageDropDown: this.renderSizePerPageDropDown,
            bgColor: "rgb(0,123,255)",
            clearSearch: true,
            clearSearchBtn: this.createCustomClearButtonForVendor,
            // paginationShowsTotal: this.renderPaginationShowsTotal,
            // sizePerPage: 100,
        }
        this.corporateOverviewVPPerformance = [];
        const ExcelFile = ReactExport.ExcelFile;
        const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
        const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

        let overallCardSection = [];

        this.props.corporateVendorOverviewOverallVolumeCards.map((card, index) => {

            let str = accounting.formatMoney(card.value);
            str = str.slice(0, -3);
            let str1 = accounting.formatMoney(card.lastYearValue);
            str1 = str.slice(0, -3);
            let yoy = '';
            // ;
            if ((card.lastYearValue) != 0) {
                yoy = ((((card.value) - (card.lastYearValue)) / (card.lastYearValue)) * 100)
            } else {
                yoy = 'NA'
            }
            let str3 = card.value;
            overallCardSection.push(
                <GrayCard
                    displayModal={this.displayModalMethod}
                    closeModal={this.closeModal}
                    type={"amount"}
                    title={getCardTitle(card.cardTitle)}
                    amount={str}
                    date={card.year}
                    growthAmount={yoy}
                    growth={yoy >= 0 ? "positive" : "negative"}
                    excessRevenue={str3}
                // updatedDate={card.updateDate}
                />
            )
        })
        if (_isEmpty(overallCardSection)) {
            overallCardSection.push(
                <div className="col-sm-3 errorText">No data available</div>

            )
        }

        let dataForChart1 = {
            data: {
                columns: [
                    ['data1', 30],
                    ['data2', 120],
                ],
                type: 'donut',
                onclick: function (d, i) { console.log("onclick", d, i); },
                onmouseover: function (d, i) { console.log("onmouseover", d, i); },
                onmouseout: function (d, i) { console.log("onmouseout", d, i); }
            },
            donut: {
                title: "Iris Petal Width"
            }
        };

        let params = this.state.params;
        params = paramsToJSON(params);
        
        return (
            <div>

                <nav className="Filters navbar">
                    <div style={{ marginLeft: "60px" }}>
                        <span className="navbar-brand nav-head"> Overview</span></div>
                    {/* <div className="export-button-wrapper"> */}
                    {/* <div className="row" style={{ padding: '0' }}>
                        <div className="filter-wrapper">
                            <div className="flex spaced"> */}
                    <div className="export-button-wrapper-overview" style={{ marginRight: "0px", width: "100px !important " }}>
                        <ul className="navbar-nav flexRowForFilters" >
                            <li className="nav-item">
                                <select style ={{ height :'38px' }} className="form-control" data-toggle="dropdown" onChange={(e) => { this.handleChangeOfDropdownextra({ name: "buyingGroupId", value: e.target.value }) }} >
                                    <option value="0" title="IMARK &amp; IMARK LLC">IMARK PLUMBING &amp; IMARK LLC</option>
                                    <option value="2">IMARK LLC</option>
                                    <option value="1">IMARK PLUMBING</option>
                                </select>
                            </li>
                            <li className="nav-item">
                                <select style ={{ height :'38px' }} className="form-control" onChange={(e) => { this.handleChangeOfDropdownextra({ name: "isCompliant", value: e.target.value }) }} >
                                    <option value="A">All</option>
                                    <option value="Y">Compliant</option>
                                    <option value="N">Non-Compliant</option>
                                    <option value="F">Eligible For FBI</option>
                                </select>
                                {/* </div> */}
                            </li>
                            <li className="nav-item">
                                <div className="btn-group">
                                    {this.renderButtonGroup()}
                                </div>
                            </li>
                            <li className="nav-item">
                                <Select onChange={(e) => this.handleChangeOfDropdownYear(e)}
                                    value={this.state.selectedYear}
                                    options={this.state.yearval} />
                            </li>
                            {showQuarter ?
                                <li className="nav-item">
                                    <select className="form-control" style ={{height:'38px',width:'80px'}} onChange={(e) => { this.handleChangeOfDropdown({ name: "quarter", value: e.target.value }) }} >
                                        <option value="1" selected={ params.quarter == 1 ? true : false} >QTR1</option>
                                        <option value="2" selected={ params.quarter == 2 ? true : false} >QTR2</option>
                                        <option value="3" selected={ params.quarter == 3 ? true : false} >QTR3</option>
                                        <option value="4" selected={ params.quarter == 4 ? true : false} >QTR4</option>
                                    </select>

                                </li>
                                :
                                <li className = "nav-item">
                                    <Select
                                        onChange={(e) => this.handleChangeOfDropdownMonth(e)}
                                        autosize={true} 
                                        value={this.state.selectedItem}
                                        options={this.state.items} />

                                </li>
                            }


                        </ul>

                        <ExcelFile filename="SUPPLIER DATA"  element={<button className="btn btn-primary" style={{ marginRight: "60px", height:'38px',marginLeft:'4px'}}>Export</button>}>
                            <ExcelSheet data={growthRebateExcelData} name="GROWTH REBATE">
                               <ExcelColumn label="SUPPLIER ID" value="vendorId" />
                                <ExcelColumn label="SUPPLIER NAME" value="vendorName" />
                                <ExcelColumn label="PROGRAM NAME" value="programName" />
                                <ExcelColumn label="TIER" value="tier" />
                                <ExcelColumn label="CRITERIA" value="criteria" />
                                <ExcelColumn label="ACTUAL SALES" value="currentYearSales" />
                                <ExcelColumn label="TARGET SALES" value="targetSales" />
                                <ExcelColumn label="GAP" value="gapAmount" />
                                <ExcelColumn label="ATTAINMENT PERCENT" value="attainmentPercent" />
                                <ExcelColumn label="REBATE AMOUNT" value="rebateAmount" />
                                <ExcelColumn label="REBATE %" value="rebatePercent" numFmt="0.00%" />
                            </ExcelSheet>
                            <ExcelSheet data={this.props.corporateOverviewVPPerformance} name="SUPPLIER PERFORMANCE">
                            <ExcelColumn label="SUPPLIER ID" value="vendorId" />
                                <ExcelColumn label="SUPPLIER NAME" value="vendorName" />
                                <ExcelColumn label="SUPPLIER SALES" value="vendorSales" />
                                <ExcelColumn label="TOTAL REBATE" value="vendorTotalRebate" />
              

                            </ExcelSheet>
                            <ExcelSheet data={this.props.corporateOverviewMemberPerformance} name="MEMBER PERFORMANCE">
                            <ExcelColumn label="MEMBER ID" value="memberId" />
                                <ExcelColumn label="MEMBER NAME" value="memberName" />
                                <ExcelColumn label="MEMBER PURCHASE" value="vendorSales" />
                                <ExcelColumn label="TOTAL REBATE" value="vendorTotalRebate" />
                                
                        

                            </ExcelSheet>
                        </ExcelFile>
                    </div>

                    {/* </div> */}

                </nav>
                {this.state.isLoading ? matLoader() : <div>


                    <div className="row" style={{ paddingBottom: "12px", paddingTop: "0", marginLeft: "60px", marginRight: "60px" }}>

                        {overallCardSection}
                    </div>
                    {/* For graph  */}

                    <div class="card-group shadow-sm mb-3" style={{ marginLeft: "60px", marginRight: "60px" }}>
                        <div class="card">
                            <div class="card-header d-flex justify-content-between align-items-center">
                                <span>Supplier Performance</span>
                                <div class="form-inline">
                                    <div class="btn-group btn-group-toggle" data-toggle="buttons">
                                        <div style={{ float: "right" }} className="displayInlineBlock">
                                            <div className="displayFlex">
                                                {/* <button className="btn btn-primary marginRight" onClick={(e) => {
                                                    this.clearVendorFilter()
                                                }}>Clear All</button> */}
                                                {this.renderButtonGroupVP()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div >
                                {this.state.selectedFilterVolume == true ?
                                    <BootstrapTable options={handleRowClickOfVendor}  ref = "vpperformance" height='350' data={this.props.corporateOverviewVPPerformance} striped hover pagination search version="4">
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="80" dataSort={true} isKey dataField='vendorId'>Id</TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="150" dataSort={true} dataField='vendorName'>Supplier Name</TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="130" dataFormat={PriceFormatter} dataSort={true} dataField='vendorSales'>Supplier Sales</TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="130" dataFormat={PriceFormatter} dataSort={true} hidden dataField='verifiedTotalRebate'>Supplier Verified</TableHeaderColumn>
                                        {/* <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="130" dataFormat={PriceFormatter} dataSort={true} dataField='imarkVerifiedRebate'>IMARK Verified</TableHeaderColumn> */}
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="40" dataFormat={this.showVendorIcon}></TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="40" dataFormat={this.showVendorInfo}></TableHeaderColumn>
                                    </BootstrapTable> : ""}

                                {this.state.selectedFilterRebate == true ?
                                    <BootstrapTable options={handleRowClickOfVendor}  ref = "vpperformance" height='350' data={this.props.corporateOverviewVPPerformance} striped hover pagination search version="4">
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="80" dataSort={true} isKey dataField='vendorId'>Id</TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="150" dataSort={true} dataField='vendorName'>Supplier Name</TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="130" dataFormat={PriceFormatter} dataSort={true} dataField='vendorTotalRebate'>Supplier Rebate</TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="130" dataFormat={PriceFormatter} dataSort={true} hidden dataField='verifiedTotalRebate'>Supplier Verified</TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="40" dataFormat={this.showVendorIcon}></TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="40" dataFormat={this.showVendorInfo}></TableHeaderColumn>
                                    </BootstrapTable> : ""
                                }
                            </div>
                        </div>
                        <div className="card">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <span>Member Performance</span>
                                <div className="form-inline">
                                    <div className="btn-group btn-group-toggle" data-toggle="buttons">

                                        <div className="displayFlex">
                                            {/* <button className="btn btn-primary marginRight" onClick={(e) => {
                                                this.clearMemberFilter()
                                            }}>Clear All</button> */}
                                            {this.renderButtonGroupMember()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>

                                {this.state.selectedFilterMemberVolume == true ?

                                    <BootstrapTable options={handleRowClickOfMember} ref = "memberperformance" height='350' data={this.props.corporateOverviewMemberPerformance} striped hover pagination search version="4" >
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="80" dataSort={true} isKey dataField='memberId'>Id</TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="150" dataSort={true} dataField='memberName'>Member Name</TableHeaderColumn>
                                        {/* <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="150" dataFormat={PriceFormatter} dataSort={true} dataField='memberSales'>Member Purchase</TableHeaderColumn> */}
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="150" dataFormat={PriceFormatter} dataSort={true} dataField='vendorSales'>Supplier Purchase</TableHeaderColumn>
                                        {/* <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="140" dataFormat={PriceFormatter} dataSort={true} dataField='imarkVerifiedPurchase'>IMARK Verified</TableHeaderColumn> */}
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="40" dataFormat={this.showMemberIcon}></TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="150" dataFormat={PriceFormatter} dataSort={true} hidden dataField='verifiedTotalRebate'>Member Verified</TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="40" dataFormat={this.showMemberPopUp}></TableHeaderColumn>

                                    </BootstrapTable> : ""}
                                {this.state.selectedFilterMemberRebate == true ?

                                    <BootstrapTable options={handleRowClickOfMember} ref = "memberperformance" height='350' data={this.props.corporateOverviewMemberPerformance} striped hover pagination search version="4">
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="80" dataSort={true} isKey dataField='memberId'>Id</TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} tdStyle={{ whiteSpace: 'normal' }} width="150" dataSort={true} dataField='memberName'>Member Name</TableHeaderColumn>
                                        {/* <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="150" dataFormat={PriceFormatter} dataSort={true} dataField='memberPurchase'>Member Purchase</TableHeaderColumn> */}
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="150" dataFormat={PriceFormatter} dataSort={true} dataField='vendorTotalRebate'>Rebate Earned</TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="40" dataFormat={this.showMemberIcon}></TableHeaderColumn>
                                        <TableHeaderColumn thStyle={{ whiteSpace: 'normal' }} width="40" dataFormat={this.showMemberPopUp}></TableHeaderColumn>

                                    </BootstrapTable> : ""}
                                {this.state.showMemberInvoice ?
                                    <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: "block" }}>

                                        <div className="modal-dialog" role="document" style={{ minWidth: "100px" }}>

                                            <div className="modal-content" style={{ width: "700px" }}>

                                                <div className="modal-header">
                                                    <h5 className="modal-title" > Invoices Per PO for {this.state.memberName}</h5>
                                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={(e) => { this.closeMemberInvoice() }} >
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                                <div className="modal-body" >
                                                    {/* <div className="card-deck">
                    <div className="card shadow-sm mb-3">

                        <div className="card-header">
                       
                            </div>
                        <div className="card-body" style={{ maxHeight: "300" }}>  */}

                                                    <BootstrapTable height='300' data={this.props.corporateOverviewMPInvoices} hover version="4">
                                                        <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataSort={true} isKey dataField='vendorId'>Supplier Id</TableHeaderColumn>
                                                        <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='vendorName'>Supplier Name</TableHeaderColumn>
                                                        <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='ratio'>Ratio</TableHeaderColumn>
                                                    </BootstrapTable>
                                                    {/* </div>
                    </div>
                </div> */}
                                                    <div >

                                                        <span className="errorText">{}</span>
                                                    </div>
                                                </div>

                                                <div className="modal-footer">
                                                    <button type="button" onClick={(e) => { this.closeMemberInvoice() }} className="btn btn-secondary" data-dismiss="modal">Close</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div> : ''
                                }

                            </div>
                        </div>

                    </div>

                    {this.state.showVendorInvoice ?
                        <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: "block" }}>

                            <div className="modal-dialog" role="document" style={{ minWidth: "100px" }}>

                                <div className="modal-content" style={{ width: "700px" }}>

                                    <div className="modal-header">
                                        <h5 className="modal-title" > Invoices Per PO for {this.state.vendorName}</h5>
                                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={(e) => { this.closeVendorInvoice() }} >
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </div>
                                    <div className="modal-body" >
                                        {/* <div className="card-deck">
                    <div className="card shadow-sm mb-3">

                        <div className="card-header">
                       
                            </div>
                        <div className="card-body" style={{ maxHeight: "300" }}>  */}

                                        <BootstrapTable height='300' data={this.props.corporateOverviewVPInvoices} hover version="4">
                                            <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataSort={true} isKey dataField='memberId'>Member Id</TableHeaderColumn>
                                            <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='memberName'>Member Name</TableHeaderColumn>
                                            <TableHeaderColumn tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='ratio'>Ratio</TableHeaderColumn>
                                        </BootstrapTable>
                                        {/* </div>
                    </div>
                </div> */}
                                        <div >

                                            <span className="errorText">{}</span>
                                        </div>
                                    </div>

                                    <div className="modal-footer">
                                        <button type="button" onClick={(e) => { this.closeVendorInvoice() }} className="btn btn-secondary" data-dismiss="modal">Close</button>
                                    </div>
                                </div>
                            </div>
                        </div> : ''
                    }


                    <div class="card shadow-sm mb-3" style={{ marginLeft: "60px", marginRight: "60px" }}>
                        {/* <div class="card-header">Growth Rebate</div> */}
                        {this.state.selectedFilterGrowthstate == true ?
                             <div className="card-body">
                            
                             <h5 style={{ textDecorationLine: 'underline', marginBottom:'-20px'}}>
                                 Growth Rebate
                                 <div className="form-inline" style ={{float: 'right'}} >
                                <div className="btn-group btn-group-toggle" data-toggle="buttons">

                                    <div className="displayFlex">
                                      
                                        {this.renderButtonGrowthIndividual()}
                                    </div>
                                </div>
                            </div></h5>
                            <BootstrapTable search height='400' data={this.props.corporateOverviewGrowthRebateVendortab} striped hover version="4">
                                    <TableHeaderColumn width="100" tdStyle={{ whiteSpace: 'normal' }} isKey dataSort={true} dataField='vendorId'>Id</TableHeaderColumn>
                                    <TableHeaderColumn width="130" tdStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='vendorName'>Supplier</TableHeaderColumn>
                                    <TableHeaderColumn width="150" tdStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='programName'>Program</TableHeaderColumn>
                                    <TableHeaderColumn width="130" tdStyle={{ whiteSpace: 'normal' }} dataSort={true} dataFormat={this.TierCriteria} dataField='criteria'>Criteria</TableHeaderColumn>
                                    <TableHeaderColumn width="80" tdStyle={{ whiteSpace: 'normal' }} dataFormat={this.TierComponent} dataSort={true} dataField='tier'>Level</TableHeaderColumn>
                                    <TableHeaderColumn width="130" tdStyle={{ whiteSpace: 'normal', wordBreak: 'break-all', overflowWrap: 'break-word' }} bodyStyle={{ width: 500, maxWidth: 500, wordBreak: 'break-all' }} dataFormat={this.PoundSalesCalculation} dataSort={true} dataField='currentYearSales'>Actual Volume</TableHeaderColumn>
                                    <TableHeaderColumn width="120" tdStyle={{ whiteSpace: 'normal' }} dataFormat = {this.PoundCurrencyTargetCalculation} dataSort={true} dataField='targetSales'>Target Volume</TableHeaderColumn>
                                    <TableHeaderColumn width="120" tdStyle={{ whiteSpace: 'normal' }} dataFormat={this.PoundCurrencyGapCalculation} dataSort={true} dataField='gapAmount'>GAP</TableHeaderColumn>
                                    <TableHeaderColumn width="100" tdStyle={{ whiteSpace: 'normal' }} dataFormat={this.AttainmentComp} dataSort={true} dataField='attainmentPercent'>Attainment(%)</TableHeaderColumn>
                                    <TableHeaderColumn width="100" tdStyle={{ whiteSpace: 'normal' }} dataFormat={PriceFormatter} dataSort={true} dataField='rebateAmount'>REBATE($) </TableHeaderColumn>
                                    <TableHeaderColumn width="100" tdStyle={{ whiteSpace: 'normal' }} dataFormat={PercentFormatter} dataSort={true} dataField='rebatePercent'>REBATE (%)</TableHeaderColumn>


                                </BootstrapTable> </div> : ""}

                                {this.state.selectedFilterIndividualGrowth== true ?
                                 <div className="card-body">
                                 <h5 style={{ textDecorationLine: 'underline', marginBottom:'-20px'}}>
                                     Growth Rebate Individual Level
                                     <div className="form-inline" style ={{float: 'right'}}>
                                    <div className="btn-group btn-group-toggle" data-toggle="buttons">

                                        <div className="displayFlex" >
                                          
                                            {this.renderButtonGrowthIndividual()}
                                        </div>
                                    </div>
                                </div></h5>
                                 
                                    <BootstrapTable search height='300' data={this.props.getDashboardIndividualGrowthRebate} striped hover version="4">
                                    <TableHeaderColumn width="120" tdStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='vendorName'>Supplier</TableHeaderColumn>
                                    <TableHeaderColumn width="120" tdStyle={{ whiteSpace: 'normal' }} isKey = "true" dataSort={true} dataField='programName'>Program</TableHeaderColumn>
                                    <TableHeaderColumn width="130" tdStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='memberName'>Member</TableHeaderColumn>
                                    {/* <TableHeaderColumn width="130" tdStyle={{ whiteSpace: 'normal' }} dataSort={true} dataFormat={this.GrowthTier} dataField='rebateTierVendor'>Growth</TableHeaderColumn> */}
                                    <TableHeaderColumn width="130" tdStyle={{ whiteSpace: 'normal' }} dataSort={true} dataFormat={this.GrowthTier} dataField='rebateTierVendor'>Individual Growth(Supplier) </TableHeaderColumn>
                                    <TableHeaderColumn width="100" dataFormat={this.RebateVerified} dataSort={true} dataField='rebatePercentList'>REBATE (%)</TableHeaderColumn>
                                    <TableHeaderColumn width="100" dataFormat={PriceFormatter} tdStyle={{ whiteSpace: 'normal' }} dataSort={true} dataField='rebate'>REBATE ($)</TableHeaderColumn>
                                    </BootstrapTable>
                                    </div>
                          
                                     : ""}
                        <div class="card-footer" style={{ textAlign: 'center' }}>
                            All Records Are YTD Till {monthName(this.state.selectedItem.label)},{params.year}</div>

                    </div>


                    <div className="autoHeight">
                    </div>
                </div>}
            </div>

        )
    }
}
function mapStateToProps(state) {
    let rebateNamess = [];
    let rebateNamesProps = _get(state, 'corporate.rebateNames', []);
    rebateNamesProps && rebateNamesProps.map((rebateName, index) => {
        let rebateNameObj = {
            key: index,
            text: rebateName.rebateTypeName,
            value: index
        }
        rebateNamess.push(rebateNameObj)
    })

    let groupRebateNames = [];
    let groupRebateNamesProps = _get(state, 'corporate.overviewGroupRebateNames', []);
    groupRebateNamesProps && groupRebateNamesProps.map((rebateName, index) => {
        let groupRebateNamesObj = {
            key: index,
            text: rebateName.rebateTypeName,
            value: index
        }
        groupRebateNames.push(groupRebateNamesObj)
    })

    let sourceNames = [];
    let sourceNameprops = _get(state, 'corporate.overviewSourceNames', []);
    sourceNameprops && sourceNameprops.map((sourceName, index) => {
        let sourceNameObj = {
            key: index,
            text: sourceName.source,
            value: index
        }
        sourceNames.push(sourceNameObj)
    })
    let vpNames = [];
    let vpNameProps = _get(state, 'corporate.overviewVpNames', []);
    vpNameProps && vpNameProps.map((vpName, index) => {
        let vpNameObj = {
            key: index,
            text: vpName.vpName,
            value: index
        }
        vpNames.push(vpNameObj)
    })
    return {
        vpNames: vpNames,
        rebateNamesList: rebateNamess,
        sourceNamesList: sourceNames,
        groupRebateNamesList: groupRebateNames,
        corporateVendorOverviewOverallVolumeCards: _get(state, 'corporate.corporateVendorOverviewOverallVolumeCards', []),
        // corporateOverviewRebateTypeCards: _get(state, 'corporate.corporateOverviewRebateTypeCards', []),
        corporateOverviewVPPerformance: _get(state, 'corporate.corporateOverviewVPPerformance', []),
        corporateOverviewMemberPerformance: _get(state, 'corporate.corporateOverviewMemberPerformance', []),
        corporateOverviewGrowthRebateVendortab: _get(state, 'corporate.corporateOverviewGrowthRebateVendortab', []),
        corporateOverviewGroupRebates: _get(state, 'corporate.corporateOverviewGroupRebates', []),
        corporateOverviewVPInvoices: _get(state, 'corporate.corporateOverviewVPInvoices', []),
        corporateOverviewMPInvoices: _get(state, 'corporate.corporateOverviewMPInvoices', []),
        getMonthsFilter: _get(state, 'corporate.getMonthsFilter', []),
        tabTracking: _get(state, 'corporate.tabTracking', []),
        getDashboardIndividualGrowthRebate:_get(state,'vendor.getDashboardIndividualGrowthRebate',[]),
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getCorporateVendorOverviewOverallVolumeCardsAPI: getCorporateVendorOverviewOverallVolumeCards,
        getCorporateOverviewVPPerformanceAPI: getCorporateOverviewVPPerformance,
        getCorporateOverviewMemberPerformanceAPI: getCorporateOverviewMemberPerformance,
        getCorporateOverviewGrowthRebateVendortabAPI: getCorporateOverviewGrowthRebateVendortab,
        getCorporateOverviewVPInvoicesAPI: getCorporateOverviewVPInvoices,
        getCorporateOverviewMPInvoicesAPI: getCorporateOverviewMPInvoices,
        getMonthsFilterAPI: getMonthsFilter,
        tabTrackingAPI:tabTracking,
        getDashboardIndividualGrowthRebateAPI:getDashboardIndividualGrowthRebate,
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(RebateView);
